import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const fetchAllVendors = () => {
  return Api(endPoints.allVendors, null, requestType.GET);
};
export const updateVendorStatus = (id, params) => {
  return Api(`${endPoints.updateVendor}/${id}`, params, requestType.POST);
};
export const getVendorDetails = (id) => {
  return Api(`${endPoints.getVendorDetails}/${id}`, null, requestType.GET);
};
export const getVendorOrders = (id, params) => {
  return Api(`${endPoints.getVendorOrders}/${id}`, params, requestType.GET);
};

export const createVendor = (params) => {
  return Api(endPoints.createVendor, params, requestType.POST);
};
